<template>
  <div style="margin: 100px;">
    <div class="main container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="专家列表" name="first">
                    <Expert ref="training"></Expert>
                </el-tab-pane>
                <el-tab-pane label="报名列表" name="second">
                  <Registration ref="registration"></Registration>
                </el-tab-pane>
                <el-tab-pane label="申请列表" name="third">
                  <Application ref="application"></Application>
                </el-tab-pane>
            </el-tabs>
    </div>
  </div>
</template>

<script>
import Expert from './components/expert.vue'
import Registration from './components/registration.vue'
import Application from './components/application.vue'
export default {
  name: "zxc",
  components: {
    Expert,
    Registration,
    Application
  },
  data() {
    return {
      activeName: 'first',
    };
  },
  methods: {
    handleClick(){
     if(this.activeName=='second'){
      this.$refs.registration.getList()
    }
     if(this.activeName=='third'){
      this.$refs.application.getList()
    }
    }
  },

};
</script>

<style lang="scss" scoped>
.tables {
  margin-top: 50px;
}

.menu-button {
  color: #2970EC
}

::v-deep.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
